export default __webpack_public_path__ + "static/pragicts-secops-banner-cybersecurity-complex-8073030e09a5b9c9ed9acb5ee6fd35c5.jpg";